import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Paper, Button } from '@material-ui/core'
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import useAxios from '@use-hooks/axios';
import fetch from "isomorphic-unfetch";
const axios = require('axios').default;
//const fetch = require("node-fetch");
const baseUrl = process.env.NEXT_STATIC_BASE_URL || "http://127.0.0.1:8011/";
//let MoneyButton = require('@moneybutton/react-money-button').default

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 3,
        backgroundColor: '#394b59',
        color: '#a3de9e',
        padding: 0,
        margin: 0
    },
    paper: {
        backgroundColor: '#6c757d',
        padding: '25px',
        margingLeft: '5px',
        color: '#a3de9e',
    },
    table: {
        minWidth: 800,
    },
}));

const styles = {
    idle: {
      backgroundColor: "white",
      color: "black"
    },
    ok: {
      backgroundColor: "green",
      color: "white"
    },
    error: {
      backgroundColor: "red",
      color: "white"
    }
  };

const Wallet = ({ heading, url, method }) => {
    const classes = useStyles();
    const [state, setState] = useState("idle");
    const [response, setResponse] = useState();
    const [wallet, setWallet] = useState([
        {
            id: 0,
            macAddress: '',
            name: 'My Wallet',
            balance: 0,
            transactions: [],
            packets: [{
                metadata: {}
            }]
        }
    ]);
  
    const fetchWallet = async ev => {
        fetch(baseUrl + url, { method })
            .then((response) => {
                setState('ok');
                return response.json();
            })
            .then((json) => {
                setWallet(json);
                console.log(json);
            });
    }
    

    return (
        <div className={classes.root}>
            
        
            <Grid container className={classes.root} spacing={2}>
                <Grid item xs={12}>
                <h2>Your Wallet</h2>
            <div>
                {wallet[0]['id']}
            </div><br/>
            <div>
                <Button
                    onClick={fetchWallet}
                    variant='contained'
                    color='secondary'
                >
                    Fetch Wallet
                </Button>
            </div><br />
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3}>                        
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>Id</Typography>
                                {wallet[0]['id']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>Description</Typography>
                                {wallet[0]['description']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>Name</Typography>
                                {wallet[0]['name']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>Balance</Typography>
                                {wallet[0]['balance']}
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3}>                        
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>IPV4</Typography>
                                {wallet[0]['ipv4']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>IPV6</Typography>
                                {wallet[0]['ipv6']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>MAC</Typography>
                                {wallet[0]['macAddress']}
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper className={classes.paper}>
                                <Typography variant='h6' justify='center'>MASK</Typography>
                                {wallet[0]['mask']}
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                    <Grid container justify='center'>
                        <Grid item>
                        <h2>Transactions</h2>                        
                            <React.Fragment>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="right">Description</TableCell>
                                                <TableCell align="right">Amount</TableCell>
                                                <TableCell align="right">Payee</TableCell>
                                            </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {wallet[0].transactions.map((tx, idx) => {
                                                    return (
                                                        <TableRow key={idx}>
                                                            <TableCell component="th" scope="row">
                                                                {tx.id}
                                                            </TableCell>
                                                            <TableCell align="right">{tx.description}</TableCell>
                                                            <TableCell align="right">{tx.amount}</TableCell>
                                                            <TableCell align="right">{tx.payee}</TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </React.Fragment>
                        </Grid>
                    </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Grid container justify='center'>
                            <Grid item>
                            <h2>Packets</h2>                        
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} aria-label="simple table">
                                                <TableHead>
                                                <TableRow>
                                                    <TableCell>Packet Id</TableCell>
                                                    <TableCell align="right">MAC</TableCell>
                                                    <TableCell align="right">IPV4</TableCell>
                                                    <TableCell align="right">IPV6</TableCell>
                                                    <TableCell align='right'>Mask</TableCell>
                                                    <TableCell align="right">Value</TableCell>
                                                </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {wallet[0].packets.map((packet, idx) => {
                                                        return (
                                                            <TableRow key={idx}>
                                                                <TableCell component="th" scope="row">
                                                                    {packet.packetId}
                                                                </TableCell>
                                                                <TableCell align="right">{packet.metadata.macAddress}</TableCell>
                                                                <TableCell align="right">{packet.metadata.ipv4}</TableCell>
                                                                <TableCell align="right">{packet.metadata.ipv6}</TableCell>
                                                                <TableCell align="right">{packet.metadata.subnetMask}</TableCell>
                                                                <TableCell align="right">{packet.value}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </React.Fragment>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>
        
    );
};

const WalletMain = () => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.root}>
                <Paper className={classes.paper} elevation={3} style={{ padding: '15px', margin: '10px' }}>
                    <Wallet heading='Wallet' method='GET' url={'wallet'} />
                </Paper>                
            </div>            
        </React.Fragment>
    )
}

export default WalletMain;